import { push } from '@lagunovsky/redux-react-router';
import React, { FunctionComponent, ReactNode, useEffect, } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {redirect, redirectBack, redirectPKCE} from '../../store/middlewares/redirect';
import { appRedirectionUpdated} from '../../App/app';
import { AppDispatch, RootState } from '../../store/store';
import Loading from '../../pages/Loading/Loading';

interface Props {
}

const AuthorizedRoute:FunctionComponent<Props> = ( props ) => {


  const authenticated = useSelector( (state:RootState) => state.app.authentication );
  const switchToEmailFlow = useSelector( (state:RootState) => state.app.attributes['custom:switch_to_email_flow'] === 'true' ? true : false  );

  const {
    authorization_code,
    redirect_uri,
  } = useSelector( (state:RootState) => state.app.searchParameters );

  const { redirect_app, language }= useSelector( (state:RootState) => state.app );

  const dispatch = useDispatch<AppDispatch>();

  useEffect( () => {

    if ( authenticated === 'succeeded' && redirect_app ) {


      // Redirect user if he tried to visit a page of this app, e.g. /settings
      console.log( 'app redirect flow triggered' );

      dispatch( push( redirect_app ) );
      dispatch( appRedirectionUpdated( '' ) );


    } else if ( authenticated === 'succeeded' && authorization_code && redirect_uri ) {

      console.log( 'PKCE flow triggered' );

      dispatch( redirectPKCE() )

    } else if ( authenticated === 'succeeded' && redirect_uri ) {

      console.log( 'Default redirect flow triggered' );

      dispatch( redirect() )

    } else if ( authenticated === 'succeeded' && !authorization_code && !redirect_uri) {
      dispatch(redirectBack());
    }

    // Redirect to client / dashboard as default
    else if ( authenticated === 'succeeded' ) {
      // Default flow
      dispatch(redirectBack());
    }

  }, [ authenticated ] );


  if ( authenticated === 'succeeded' && redirect_app ) {
    return <Loading />;
  } else if ( authenticated === 'succeeded' && authorization_code && redirect_uri ) {
    //  PKCE Flow
    return <Loading />;
  } else if ( authenticated === 'succeeded' && redirect_uri ) {
    //  Implicit Flow
    return <Loading />;
  } else if ( authenticated === 'succeeded' && !redirect_uri ) {
    return <Loading />;
  } else if ( authenticated === 'pending' ) {
    return <Loading />;
  } else {
    return <div>{props.children}</div>;
  }
}

export default AuthorizedRoute;
